import ApiClient from './ApiClient';

export const getStampHistory = async (params: any): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/jsp/sj/stamp_history/${companyCode}`, params);
  return response.data;
};

export default getStampHistory;
